module.exports = __webpack_public_path__ + "static/media/TEOMainHeader.69fd73b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/TEOMainHeader.svg
// module id = 675
// module chunks = 0